import ErrorComponent from "@/components/atoms/ErrorComponent";
import UserHeader from "@/components/molecules/card-headers/UserHeader";
import CompaniesCard from "@/components/molecules/cards/companies/UserCompaniesCard";
import UserDetailsCard from "@/components/molecules/cards/users/UserDetailsCard";
import UserNotesCard from "@/components/molecules/cards/users/UserNotesCard";
import { UUID_REGEX } from "@/constants/regexs";
import { pluralize } from "@/helpers/utils";
import IUser from "@/interfaces/IUser";
import { faComment, faUser } from "@fortawesome/free-solid-svg-icons";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import { FC, useState } from "react";
import { Card, Col, Nav, Row, Tab } from "react-bootstrap";
import { useParams } from "react-router-dom";
import SimpleBar from "simplebar-react";

const UserView: FC = () => {
  const { id } = useParams<{ id: string }>();
  const [user, setUser] = useState<IUser>();
  const [totals, setTotals] = useState({
    companies: 0,
    people: 0,
    commissions: 0,
    notes: 0,
  });

  const onGetTotal = (key: string, total: number) => {
    setTotals((prev) => ({ ...prev, [key]: total }));
  };

  if (!id || !UUID_REGEX.test(id)) {
    return (
      <ErrorComponent error={{ status: 404, data: {} }} absolute returnButton />
    );
  }

  return (
    <div className="formalys-page formalys-detail-page">
      {user && <UserHeader id={id} />}
      <Row className="g-3">
        <Col xxl={4} xl={5}>
          <UserDetailsCard id={id} callBack={setUser} />
        </Col>
        {user && (
          <Col xxl={8} xl={7}>
            <Card>
              <Tab.Container defaultActiveKey={"companies"}>
                <SimpleBar>
                  <Card.Header className="p-0 border-bottom">
                    <Nav className="nav-tabs border-0 flex-nowrap tab-contact-details">
                      <Nav.Item>
                        <Nav.Link
                          eventKey="companies"
                          className="d-flex align-items-center py-3 px-x1 mb-0"
                        >
                          <FontAwesomeIcon
                            icon={faUser}
                            className="text-600 tab-icon"
                          />
                          <h6 className="text-600 mb-0 ms-1">
                            {pluralize("Entreprise", totals.companies)}
                            &nbsp;(
                            {totals.companies})
                          </h6>
                        </Nav.Link>
                      </Nav.Item>
                      <Nav.Item>
                        <Nav.Link
                          eventKey="notes"
                          className="d-flex align-items-center py-3 px-x1 mb-0"
                        >
                          <FontAwesomeIcon
                            icon={faComment}
                            className="text-600 tab-icon"
                          />
                          <h6 className="text-600 mb-0 ms-1">
                            {pluralize("Note", totals.notes)}&nbsp;(
                            {totals.notes})
                          </h6>
                        </Nav.Link>
                      </Nav.Item>
                    </Nav>
                  </Card.Header>
                </SimpleBar>
                <Card.Body className="bg-light">
                  <Tab.Content>
                    <Tab.Pane eventKey="companies">
                      <CompaniesCard
                        userId={id}
                        onGetTotal={(total) => onGetTotal("companies", total)}
                      />
                    </Tab.Pane>
                    <Tab.Pane eventKey="notes">
                      <UserNotesCard
                        id={id}
                        onGetTotal={(total) => onGetTotal("notes", total)}
                      />
                    </Tab.Pane>
                  </Tab.Content>
                </Card.Body>
              </Tab.Container>
            </Card>
          </Col>
        )}
      </Row>
    </div>
  );
};

export default UserView;
